import { ReactNode } from "react";

import { PieceAdminResponseDTO } from "../../openapi-generated-client";
import PieceConfirmWrapper from "./pieceConfirmDisplay";
import PieceList from "./pieceList";
import "./pieceList.css";

interface PieceConfirmListProps {
    pieceLinkPrefix: string;
    pieces: PieceAdminResponseDTO[],
    leftOriented?: boolean,
    breakPoints?: any;
    searchQuery?: string;

    hideInstrumentation?: boolean;
    hideIconDisplay?: boolean;
    hideInfos?: boolean;
    hideComposer?: boolean;
    children?: ReactNode;

    displayType?: ReactNode;
    refetch?: () => void;
}

export default function PieceConfirmList(props: PieceConfirmListProps) {

    return <PieceList displayProps={{
        "linkPrefix": props.pieceLinkPrefix,
        "hideComposer": props.hideComposer,
        "hideIconDisplay": props.hideIconDisplay,
        "hideInfos": props.hideInfos,
        "hideInstrumentation": props.hideInstrumentation
    }} pieces={props.pieces.map(p => {
        return {
            piece: p.piece,
            wrapper: <PieceConfirmWrapper refetch={props.refetch} pieceData={p}/>
        }
    })}/>;

}